module.exports = __webpack_public_path__ + "img/833af62f46f647c64806b015962e8059.svg";